import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Button, Dialog } from '@optimus-web/core';

export interface DisableScimWarningDialogProps {
    active: boolean;
    onClose: () => void;
    onSubmit: () => void;
}

export function DisableScimWarningDialog({ onSubmit, onClose, active }: DisableScimWarningDialogProps) {
    const handleSubmit = () => {
        onSubmit();
        onClose();
    };

    return (
        <Dialog
            active={active}
            onClose={onClose}
            title={<LocalizedText textKey={TextKey.DeactivateScimConfirmationTitle} />}
            footer={{
                primary: (
                    <Button size="medium" type="button" variant="destructive" onClick={handleSubmit}>
                        <LocalizedText textKey={TextKey.Disable} />
                    </Button>
                ),
                secondary: (
                    <Button size="medium" type="button" variant="tertiary" onClick={onClose}>
                        <LocalizedText textKey={TextKey.Cancel} />
                    </Button>
                ),
            }}
        >
            <LocalizedText textKey={TextKey.DeactivateScimConfirmationDescription} />
        </Dialog>
    );
}
